import { createAsyncThunk } from '@reduxjs/toolkit';

// TODO test with slug page
export const fetchWithLanguage = (name, request, condition) =>
    createAsyncThunk(
        name,
        async (params, { getState }) => {
            const { languageState } = getState();
            // console.log('fetchWithLanguage params', params);
            const response = await request({
                language: languageState.language.code,
                country: languageState.country.code,
                ...params,
            });

            return response.data;
        },
        { condition },
    );
